{
  "activity": {
    "duration": "Durée",
    "durationUnit": "min",
    "intensity": "Intensité",
    "title": "Activité physique"
  },
  "admin": {
    "logout": "Déconnexion",
    "title": "Administration"
  },
  "atoms": {
    "richText": {
      "h5": "Titre",
      "normal": "Normal"
    }
  },
  "button": {
    "accept": "Accepter",
    "back": "Retour",
    "cancel": "Annuler",
    "edit": "Modifier",
    "generate": "Générer",
    "next": "Suivant",
    "pending": "Chargement…",
    "reject": "Rejeter",
    "save": "Sauvegarder",
    "submit": "Soumettre",
    "tryAgain": "Réessayer",
    "upload": "Envoyer",
    "validate": "Valider"
  },
  "clipboard": {
    "unsupported": "La copie dans le presse-papiers n'est pas disponible",
    "copied": "Contenu copié dans le presse-papiers",
    "failed": "Échec de la copie du contenu dans le presse-papiers"
  },
  "condition": {
    "term": "Terme",
    "unspecified": "Non renseigné"
  },
  "devices": {
    "libreLink": "Via LibreView",
    "manual": "Saisie manuelle",
    "pen": "Stylo à insuline",
    "pump": "Pompe à insuline",
    "reader": "Lecteur",
    "sensor": "Capteur interstitiel",
    "upload": "Téléverser",
    "uploadSuccess": "Téléversement réussi",
    "uploadError": "Erreur de téléversement",
    "uploadErrorDescription": "Veuillez réessayer ou contacter le support si le problème persiste.",
    "uploadPaused": "Téléversement en pause",
    "lastUpload": "Dernier téléversement",
    "neverUploaded": "Jamais",
    "deviceDetected": "Appareil détecté",
    "manyDevicesDetected": "{{count}} appareils détectés. Veuillez connecter un seul appareil.",
    "tandem": {
      "name": "Tandem",
      "instructions": "Connectez la pompe avec le câble USB puis cliquez sur '$t(devices.tandem.upload)'",
      "instructionsNoDevices": "Connectez la pompe avec le câble USB puis cliquez sur '$t(devices.tandem.searchForDevice)'",
      "searchForDevice": "Rechercher une pompe",
      "upload": "Téléverser",
      "noDeviceFound": "Aucune pompe trouvée",
      "deviceDetected": "Pompe détectée",
      "manyDevicesDetected": "{{count}} pompes détectées. Veuillez connecter une seule pompe."
    },
    "omnipod": {
      "name": "Omnipod",
      "instructions": "Connectez le PDM avec le câble USB puis cliquez sur '$t(devices.omnipod.upload)'",
      "instructionsNoDevices": "Connectez le PDM avec le câble USB puis cliquez sur '$t(devices.omnipod.searchForDevice)'",
      "searchForDevice": "Rechercher un PDM",
      "upload": "Téléverser",
      "noDeviceFound": "Aucun PDM trouvé",
      "deviceDetected": "PDM détecté",
      "manyDevicesDetected": "{{count}} PDMs détectés. Veuillez connecter un seul PDM.",
      "uploadManually": "ou sélectionner manuellement le fichier"
    },
    "errors": {
      "driverInit": "Erreur de connexion à l'appareil, veuillez réessayer",
      "dataRead": "Erreur de lecture des données de l'appareil, veuillez réessayer",
      "connectionFailure": "Échec de la connexion à l'appareil, veuillez vérifier la connexion USB et réessayer",
      "cancelled": "Téléversement annulé"
    },
    "pause": {
      "usbConnectionLost": "Connexion perdue. Veuillez vérifier que le câble usb est connecté aux deux extrémités"
    },
    "cancel": "Annuler"
  },
  "nurseInclusion": {
    "doctorSelect": "Médecin télésurveillant",
    "patientInfo": "Informations patient",
    "banner": "Le patient recevra un mail de connexion une fois que le médecin aura validé l’inclusion",
    "inclusionReason": "Raison de la proposition d’inclusion",
    "inclusionSent": "Proposition envoyée avec succès",
    "inclusionProposal": "Proposition d’inclusion",
    "inclusionProposalBy": "Proposition d’inclusion par {{nurse}}",
    "examineSuggestion": "Examiner la demande",
    "reject": "Refuser",
    "accept": "Valider la proposition",
    "addPatient": "Proposition d’inclusion par {{nurse}}",
    "history": {
      "title": "Historique des propositions d’inclusion",
      "createdAt": "Date de demande",
      "doctor": "Médecin",
      "name": "Nom du patient",
      "birthDate": "Date de naissance",
      "email": "Adresse email",
      "status": "Statut d'inclusion"
    }
  },
  "diabetesForms": {
    "patientCreated": "Le patient a été créé avec succès",
    "clickToView": "Cliquez pour voir le patient",
    "addDescription": "Ajouter les objectifs thérapeutiques",
    "addInsulin": "Passage à l'insuline",
    "addPatient": "Ajouter le patient",
    "addNurseInclusion": "Pré-inclure un patient",
    "addPrescription": "Ajouter une ordonnance",
    "addProvider": "Nouveau prestataire",
    "criteria": "Critère d’inclusion à la télésurveillance",
    "criteriaBase": "Socle",
    "criteriaBaseInfo": "Suivi d'un(e) patient(e) ayant un diabète de type 1, mise en \nroute d'une insuline basale chez un diabétique de type 2, suivi \ndu DT2 sous multi-injections ",
    "criteriaLevel1": "Niveau 1",
    "criteriaLevel1Info": "Découverte d'un diabète de type 1 chez un(e) patient(e) adulte, \nsuivi du diabète de type 1 chez un(e) patient(e) adolescent(e), \nsituation de déséquilibres transitoires (corticothérapie), \nsuivi d’un diabète gestationnel",
    "criteriaLevel2": "Niveau 2",
    "criteriaLevel2Info": "Découverte d'un diabète de type 1 chez un(e) patient(e)\nadolescent(e), suivi d'adolescents en écarts de soins,\ngrossesse d'une femme diabétique",
    "criteriaMeaningBase": "Ce critère d'inclusion correspond à un remboursement médecin de niveau socle",
    "criteriaMeaningLevel1": "Ce critère d'inclusion correspond à un remboursement médecin de niveau 1",
    "criteriaMeaningLevel2": "Ce critère d'inclusion correspond à un remboursement médecin de niveau 2",
    "dates": "Programme en cours",
    "diabetesType": "Type de diabète",
    "duration": "Durée du télésuivi (en mois)",
    "eitherObjectiveOrFile": "Les objectifs thérapeutiques doivent être remplis et/ou un fichier doit être ajouté",
    "generatePrescription": "Générer l'ordonnance",
    "goals": "Protocole de prise en charge et objectifs thérapeutiques",
    "goalsNone": "Aucun objectif défini",
    "goalsShort": "Objectifs thérapeutiques",
    "hasUntilTerm": "Suivi jusqu'au terme",
    "hsp": "Prestataire de santé",
    "inclusionCriteriaLabel": {
      "adultDiscoveryD1": "Découverte d'un DT1 chez un adulte",
      "adultMonitoringD1": "Suivi du DT1 chez un adulte",
      "basePrice": "Tarif Socle",
      "corticotherapie": "Situation de déséquilibres transitoires",
      "gestationalInsulined": "Diabète gestationnel sous insuline",
      "level1Price": "Tarif Niveau 1",
      "level2Price": "Tarif Niveau 2",
      "monitoringD2": "Suivi du DT2 sous insuline",
      "noRefund": "Non Remboursé",
      "pregnateD": "Grossesse d'une femme diabétique",
      "pumpHybridInitiation": "Initiation et suivi d'une pompe à insuline en boucle semi-fermée",
      "pumpInitiation": "Initiation d'un traitement par pompe à insuline",
      "pumpMonitoring": "Suivi d'un traitement par pompe à insuline",
      "startBasalD2": "Mise en route d'une insuline basale chez un DT2",
      "teenCareGap": "Suivi d'adolescents en écarts de soins",
      "teenDiscoveryD1": "Découverte d'un DT1 chez un adolescent",
      "teenMonitoringD1": "Suivi du DT1 chez un adolescent"
    },
    "insuletSupportedPumps": "Insulet: Omnipod Dash et Omnipod Eros",
    "insulin": {
      "insulinPen": "Stylo",
      "insulinPump": "Pompe",
      "insulinPumpsComingSoon": "Le suivi des patients sous pompe arrive bientôt sur Stēto !",
      "noInsulin": "Sans insuline"
    },
    "insulinScheme": "Dispositif d'insulinothérapie",
    "maximumWeight": "Le poids doit être inférieur à 1000 Kg",
    "medtronicSupportedPumps": "<0>Medtronic: </0><1>MiniMed 630G, 640G et 780G </1><2>(nouveau)</2>",
    "minimumWeight": "Le poids doit être supérieur à 0 Kg",
    "months": "mois",
    "noInsulinMonitoringHelpText": "le diabète gestationnel non insuliné n’est pas éligible à la télésurveillance remboursée, la patiente ne sera donc pas accompagnée par votre infirmier(ère). Lorsque votre patiente commence une insulinothérapie, cliquez sur \"Passage à l'insuline\" pour lancer l'accompagnement infirmier.",
    "nonTelemonitoredPatient": "Patiente sans accompagnement infirmier",
    "otherHSP": "Nouveau prestataire - Stēto vous contactera",
    "periodStart": "Date de début",
    "prescription": "Ordonnance",
    "prescriptionAddition": "Ajout de l'ordonnance",
    "prescriptionDescription": "ou ajouter une ordonnance pour trois mois démarrant le",
    "prescriptionDownload": "Télécharger l'ordonnance",
    "prescriptionDuration": "Durée de prescription",
    "prescriptionGeneration": "Génération de l'ordonnance",
    "prescriptionLabel": "Ajouter un fichier",
    "prescriptionNone": "Aucune ordonnance fournie",
    "prescriptionSignSuccess": "L'ordonnance a été signée avec succès.",
    "prescriptionSignature": "Signature",
    "prescriptionTooltip": "L’ordonnance doit inclure les éléments suivants :\n\n- nom du patient\n- âge\n- poids\n- désignation “télésurveillance diabète”\n- durée: 3 mois\n- plateforme: Stēto",
    "renew": "Renouveler",
    "restartMonitoring": "Renouveler",
    "renewPatient": "Renouveler le patient",
    "renewed": "Renouvelé",
    "responsibleDoctor": "Médecin référent",
    "responsibleNurse": "Infirmier",
    "restriction": "Ce patient a déjà été suivi pendant 6 mois consécutifs en niveau 1 ou 2. Seuls les critères d'inclusion de niveau socle sont donc disponibles.",
    "signAndAddPatient": "Signer et ajouter le patient",
    "signAndRenewPatient": "Signer et renouveler le patient",
    "supportedPumpsInfo": "De nouvelles pompes seront ajoutées régulièrement dans les prochains mois",
    "supportedPumpsTitle": "Pompes disponibles sur Stēto",
    "tandemSupportedPumps": "<0>Tandem: t:slim X2 et </0><1>t:slim X2 Control IQ</1><2>(nouveau)</2>",
    "telemonitoring": "Télésurveillance",
    "termDate": "Terme de la grossesse",
    "weight": "Poids (kg)",
    "weightUnit": "kg"
  },
  "errors": {
    "emailAlreadyInUse": "Cet email est déjà utilisé par un de vos patients",
    "unknownErrorFull": "Une erreur technique est survenue. Veuillez contacter le support.",
    "accountAlreadyExists": "Ce patient a déjà un compte, merci de contacter le support.",
    "carePlanAlreadyRenewed": "Le télésuivi a déjà été renouvelé",
    "carePlansOverlapping": "Les dates de télésuivi chevauchent celles du télésuivi actuel",
    "dateFormat": "Le format de la date n'est pas valide",
    "fileSizeError": "La taille du fichier ne doit pas dépasser {{max_size}}: {{size}} / {{max_size}}",
    "or": "ou",
    "pageNotFound": "La page n'existe pas",
    "title": "Erreur",
    "unauthorizedPatientAccess": "Le patient n'existe pas ou vous n'avez pas les droits pour visualiser ce patient",
    "unknownError": "Une erreur technique est survenue",
    "userAlreadyExists": "Ce patient a déjà un compte, merci de contacter {{supportEmail}}",
    "waitAFewMinutes": "Veuillez patienter quelques minutes",
    "invalidEmail": "L'adresse email n'est pas valide",
    "invalidPhone": "Le numéro de téléphone n'est pas valide",
    "invalidCode": "Le code doit contenir 6 chiffres",
    "tooManyAttempts": "Trop de tentatives, veuillez patienter quelques minutes",
    "wrongCode": "Le code est incorrect ou a expiré"
  },
  "fileReports": {
    "noData": "Aucun rapport disponible pour ces dates"
  },
  "food": {
    "carbs": "Glucides",
    "carbsUnit": "g",
    "comments": "Commentaire",
    "meal": "Repas",
    "size": "Consistance",
    "title": "Repas"
  },
  "form": {
    "atLeastOne": "Au moins un des champs doit être rempli",
    "date": {
      "future": "La date doit être dans le passé",
      "invalid": "La date n'est pas valide",
      "past": "La date doit être dans le futur"
    },
    "email": {
      "invalid": "Adresse email non valide",
      "label": "Adresse email",
      "required": "Une adresse e-mail est requise"
    },
    "file": {
      "label": "Fichier",
      "required": "Uniquement les fichiers de type {{extensions}} sont supportés",
      "tooBig": "Le fichier ne doit pas dépasser 10 Mo"
    },
    "number": {
      "integer": "Le champs doit être un nombre entier",
      "invalid": "Le champs doit être un nombre",
      "max": "Le champs est supérieur à la valeur maximale",
      "min": "Le champs est inférieur à la valeur minimale",
      "positive": "Le champs doit être positif"
    },
    "pastDate": "La date ne peut pas être antérieure à la date actuelle",
    "phone": {
      "invalid": "Numéro de téléphone non valide",
      "label": "Numéro de téléphone",
      "required": "Un numéro de téléphone est requis"
    },
    "helperPhone": {
      "label": "Numéro de téléphone de l'aidant"
    },
    "required": "Le champs est requis",
    "text": {
      "comment": "Commentaire",
      "firstnameRequired": "Le prénom est requis",
      "lastnameRequired": "Le nom de famille est requis",
      "required": "Le champs est requis"
    }
  },
  "glycemia": {
    "hyperglycemia_one": "Hyperglycémie",
    "hyperglycemia_other": "Hyperglycémies",
    "hypoglycemia_one": "Hypoglycémie",
    "hypoglycemia_other": "Hypoglycémies",
    "title": "Glycémie"
  },
  "identityValidation": {
    "subtitle": "L'identité du patient ci-dessous doit être validée, avant de pouvoir continuer",
    "title": "Validation de l'identité de votre patient"
  },
  "impersonationWarning": "Vous êtes actuellement en mode d'impersonation",
  "inclusionAgent": {
    "accept": "Valider",
    "startTelemonitoring": "Démarrer le suivi",
    "cancel": "Annuler",
    "contactPatientTitle": "Contact du patient",
    "contactPatient": "Nous allons contacter le patient et vous notifierons de son choix",
    "disappear": "Le patient va disparaître de la liste",
    "includePatient": "Inclure le patient",
    "inclusionRequestSent": "Demande de suivi envoyée",
    "patientAccepted": "Suivi accepté par le patient",
    "phonePlaceholder": "Numéro de téléphone",
    "reject": "Décliner",
    "rejected": "Demande de suivi rejetée",
    "requiredPhone": "Nous avons besoin d'un numéro de téléphone pour proposer le suivi au patient",
    "stats": {
      "TBR": "TBR",
      "TIR": "TIR",
      "CV": "CV",
      "GMI": "GMI",
      "hypo_count": "Nb. Hypo"
    },
    "source": {
      "robot": "Agent",
      "tooltip": "Proposition d’inclusion par Agent Stēto"
    },
    "title": "Propositions d'inclusions",
    "viewOnLibreView": "Voir sur LibreView",
    "noMoreSuggestions": "Aucune proposition d'inclusion pour le moment.",
    "lastStep": "Dernière étape"
  },
  "insulin": {
    "averageInsulinPerDay": "Moy. insuline/jour",
    "averageNbBolusInjectionsPerDay": "Moy. nb. bolus/jour",
    "averageNbBolusPerDay": "Moy. nb. bolus/jour",
    "averageNbInjectionsPerDay": "Moy. nb. injections/jour",
    "basalInsulinPerDay": "Insuline basale / jour",
    "bolusInsulinPerDay": "Insuline bolus / jour",
    "carbs": "Glucides",
    "carbsRatio": "Ratio",
    "correction": "Correction",
    "fastInsulinPerDay": "Insuline rapide / jour",
    "foodInsulin": "Repas",
    "glycemia": "Glucose",
    "insulinSensitivity": "Sensibilité",
    "iob": "Insuline active",
    "quantity": "Délivrée",
    "reason": "Raison",
    "slowInsulinPerDay": "Insuline lente / jour",
    "suggested": "Suggérée",
    "suggestedCorrection": "Cor. suggérée",
    "suggestedFoodInsulin": "Repas suggérée",
    "targetGlycemia": "Glycémie cible",
    "title": "Insuline",
    "type": "Type"
  },
  "insulinPump": {
    "activeInsulinTime": "Temps insuline active",
    "basalRate": "Débit basal",
    "carbsRatio": "Ratio",
    "insulinSensitivity": "Sensibilité",
    "lastUpload": "Dernier téléchargement",
    "model": "Modèle de pompe",
    "profile": "Profil",
    "profiles": "Paramètres de la pompe",
    "targetBloodGlucose": "Glycémie cible",
    "timeRange": "",
    "total": "Total",
    "units": {
      "activeInsulinTime": "min",
      "basalRate": "U/h",
      "carbsRatio": "g/U",
      "insulinSensitivity": "mg/dL/U",
      "targetBloodGlucose": "mg/dL"
    }
  },
  "languageFlag": "🇫🇷",
  "languageFull": "🇫🇷 Français",
  "languages": {
    "en": "Anglais (English)",
    "fr": "Français"
  },
  "messaging": {
    "all": "Tous les messages",
    "deleted": "Message supprimé",
    "everybody": "Tout le monde",
    "me": "Moi",
    "medicalStaff": "Equipe médicale",
    "noMessages": "Aucun message pour le moment",
    "noNurse": "Patiente non accompagnée par votre infirmier",
    "patientOnly": "Message pour votre patient uniquement",
    "readBy": "Lu par",
    "recipient": "Destinataire ",
    "toAllPlaceholder": "Message visible par le patient et l'équipe médicale",
    "toPractitionerPlaceholder": "Message visible par l'équipe médicale seulement",
    "unread": "Non lus"
  },
  "models": {
    "activityIntensity": {
      "high": "Élevée",
      "low": "Faible",
      "medium": "Moyenne",
      "unknown": "Non spécifié"
    },
    "diabetesType": {
      "gestational": "Gestationnel",
      "gestationalNoInsulin": "DG non insuliné",
      "gestationalWithInsulin": "DG insuliné",
      "type1": "Type 1",
      "type2": "Type 2"
    },
    "nurseInclusionPatientStatus": {
      "suggestedToDoc": "Proposé",
      "doctorRefused": "Refusé",
      "patientIncluded": "Inclus",
      "unknown": "Inconnu"
    },
    "insulinReason": {
      "basal": "Insuline basale",
      "basal_short": "Basale",
      "bolus": "Insuline bolus",
      "bolus_short": "Bolus"
    },
    "insulinType": {
      "fast": "Insuline rapide",
      "fast_short": "Ins. rapide",
      "slow": "Insuline lente",
      "slow_short": "Ins. lente"
    },
    "meal": {
      "breakfast": "Petit-déjeuner",
      "dinner": "Dîner",
      "lunch": "Déjeuner",
      "snack": "Collation",
      "unknown": "Repas non spécifié"
    },
    "mealSize": {
      "heavy": "Consistant",
      "light": "Léger",
      "medium": "Moyen",
      "unknown": "Non spécifié"
    },
    "medicationSchema": {
      "insulinPen": "Stylo",
      "insulinPump": "Pompe",
      "noInsulin": "Sans insuline"
    },
    "practitionerBillingStatus": {
      "error": "Erreur",
      "processed": "Traité",
      "toProcess": "A traiter"
    },
    "practitionerBillingType": {
      "quotation": "Résumés pour cotation",
      "retrocessionDoctor": "Rétrocession Médecin",
      "retrocessionSteto": "Rétrocession Stēto"
    },
    "pumpEventCategory": {
      "basalRateChanged": "Changement de débit basal",
      "cannulaFilled": "Purge canule",
      "cartridgeFilled": "Retour piston",
      "dailyBasal": "Basal journalier",
      "podChanged": "Pod remplacé",
      "podActivated": "Pod activé",
      "podDeactivated": "Pod désactivé",
      "profileChanged": "Profil de pompe modifié",
      "tubingFilled": "Purge tubulure"
    },
    "pumpMode": {
      "closedLoop": "Mode boucle fermée",
      "manual": "Mode manuel",
      "noControl": "Mode manuel",
      "openLoop": "Mode manuel",
      "pining": "Mode manuel"
    },
    "reportCategory": {
      "other": "Autre",
      "perceivedHyperglycemia": "Hyperglycémie ressentie",
      "perceivedHypoglycemia": "Hypoglycémie ressentie",
      "severeHypoglycemia": "Hypoglycémie sévère",
      "techAlert": "Problèmes techniques"
    },
    "telemonitoringTag": {
      "active": "Active",
      "active_long": "Télésurveillance active",
      "expired": "Expirée",
      "expiredRecently": "Expirée récemment",
      "expiredRecently_long": "Télésurveillance expirée récemment",
      "expired_long": "Télésurveillance expirée",
      "expiringSoon": "Expire bientôt",
      "expiringSoon_long": "Télésurveillance expire bientôt",
      "gestationalNoInsulin": "DG non insuliné",
      "gestationalNoInsulin_long": "Diabète gestationnel non insuliné",
      "nurseAskedForReinclusion": "Réinclusion proposée",
      "nurseAskedForReinclusion_long": "Réinclusion proposée par l'infirmier",
      "onboarding": "Installation en cours",
      "onboarding_long": "Patient en cours d'installation"
    },
    "userMode": {
      "exercising": "Mode sport",
      "normal": "Mode normal",
      "sleeping": "Mode sommeil"
    },
    "contactType": {
      "nurse": "Infirmier",
      "family": "Famille",
      "helper": "Aidant",
      "unknown": "Autre"
    },
    "contactRelationship": {
      "grandParent": "Grand-parent",
      "parent": "Parent",
      "parentInLaw": "Parent par alliance",
      "partner": "Conjoint",
      "child": "Enfant",
      "sibling": "Frère ou soeur",
      "cousin": "Cousin",
      "friend": "Ami",
      "unknown": "Autre"
    }
  },
  "navbar": {
    "disconnect": "Me déconnecter",
    "myPatients": "Mes patients",
    "practitionerBilling": "Facturation"
  },
  "notifications": {
    "none": "Aucune notification active.",
    "title": "Notifications actives"
  },
  "pages": {
    "account": {
      "about": {
        "address": "12 Boulevard de Port Royal",
        "class": "Dispositif médical de classe I",
        "description": "Stēto est un produit de santé réglementé qui porte, au titre de cette réglementation, un marquage CE de classe I. Voir notice d’utilisation. L’application Stēto est une solution de télésuivi du diabète réalisée et développée par :",
        "name": "Stēto",
        "postCode": "75005 Paris",
        "rcs": "918012121 RCS de Paris",
        "title": "À propos de Stēto"
      },
      "generalInformation": {
        "title": "Informations générales"
      },
      "language": {
        "title": "Langue"
      },
      "preferences": {
        "dgNoInsulinPatientToDoctor": "Nouveau message d'une patiente DG non suivie par un infirmier",
        "doctorToNurse": "Nouveau message médecin",
        "nursePing": "Nouveau patient signalé",
        "nurseToDoctor": "Nouveau message infirmier",
        "patientExpiresSoon": "Patient télésurveillé expire bientôt",
        "patientExpiresSoonNurse": "Patient télésurveillé expire bientôt",
        "patientToNurse": "Nouveau message patient",
        "title": "Préférences de notifications par email"
      },
      "security": {
        "title": "Sécurité",
        "updatePassword": "Changer de mot de passe"
      },
      "terms": {
        "title": "Conditions générales d'utilisation"
      },
      "title": "Mon compte",
      "userHelp": {
        "contactUs": "Contactez nous à {{supportEmail}}",
        "description": "Besoin d'aide ?",
        "or": "ou",
        "title": "Besoin d'aide ?",
        "userManual": "consultez notre manuel"
      }
    },
    "search": {
      "title": "Recherche d'antériorité",
      "CTA": "Chercher",
      "CTARedirectButton": "Rechercher un patient",
      "form": {
        "dob": "Date de naissance (AAAA-MM-JJ)",
        "NIR": "Numéro NIR",
        "names": "Nom / Prénom(s)"
      },
      "table": {
        "birth_name": "Nom de naissance",
        "used_last_name": "Nom utilisé",
        "first_regulatory_first_name": "Premier prénom de naissance",
        "used_first_name": "Prénom utilisé",
        "dob": "Date de naissance",
        "gender": "Sexe",
        "status": "Statut de l’identité",
        "nir": "Numéro NIR",
        "CTA": "Voir",
        "noData": "Aucun résultat"
      }
    },
    "addMeasurement": {
      "choose": "Choisir"
    },
    "addMeasurementFile": {
      "chooseFile": "Choisir un fichier",
      "chooseMedicalDeviceToLoad": "Choisir mon dispositif médical à décharger",
      "dexcom": {
        "alreadyIntegrated": "Dexcom est déjà intégré",
        "alreadyIntegratedHelpText": "Vous avez déjà intégré votre compte Dexcom.\nSi vous souhaitez le réinitialiser, vous pouvez contacter le support au {{supportPhone}} ou nous envoyer un mail à {{supportEmail}}",
        "clarityNotEnabled": "Clarity non activé",
        "clarityNotEnabledHelpText": "Vous devez activer Clarity pour pouvoir intégrer votre compte Dexcom.\nPour cela, rendez-vous sur l'application Dexcom et activez Clarity.\nSi vous avez besoin d'aide, vous pouvez contacter le support au {{supportPhone}} ou nous envoyer un mail à {{supportEmail}}",
        "dexcomData": "Dexcom CGM",
        "integrationDenied": "L'intégration de Dexcom a été refusée",
        "integrationDeniedHelpText": "Afin que votre médecin puisse accéder à vos données de glycémie, vous devez autoriser l'accès à votre compte Dexcom.\nPour cela, vous pouvez réessayer de vous connecter à votre compte Dexcom en cliquant sur le bouton ci-dessous.",
        "integrationError": "Une erreur est survenue lors de l'intégration de Dexcom",
        "integrationErrorHelpText": "Une erreur est survenue lors de la connexion à votre compte Dexcom.\nNous vous conseillons de réessayer d'ici quelques minutes. Si cela ne fonctionne toujours pas, vous pouvez contacter le support au {{supportPhone}} ou nous envoyer un mail à {{supportEmail}}",
        "integrationSuccess": "Intégration Dexcom faite avec succès",
        "integrationSuccessHelpText": "Votre compte Dexcom a bien été intégré.\nVous pouvez maintenant accéder à vos données de glycémie dans l'application Stēto.",
        "title": "Dexcom"
      },
      "error": "Une erreur est survenue lors de l'enregistrement de votre fichier",
      "fsl": {
        "addData": "Décharger les données de mon Smartphone avec un FreeStyle Libre",
        "instructions": "Vous devez vous rendre d'abord sur le site de LibreView pour récupérer votre fichier de données CSV puis sélectionnez le fichier :"
      },
      "fslWithAbbottSmartphone": "Capteur FreeStyle Libre scanné avec mon smartphone ABBOTT",
      "noFileChosen": "Aucun fichier choisi",
      "success": "Votre fichier a bien été enregistré"
    },
    "login": {
      "practitionerTitle": "Vous êtes un soignant",
      "practitionerInstructions": "Accédez à votre espace soignant sur l'application web Stēto via ce lien : ",
      "patientTitle": "Vous êtes un patient",
      "emailLabel": "Adresse email",
      "phoneLabel": "Numéro de téléphone",
      "emailPlaceholder": "prenom.nom@exemple.fr",
      "phonePlaceholder": "06 12 34 56 78",
      "requestEmailCode": "Recevoir un code par email",
      "requestSmsCode": "Recevoir un code par SMS",
      "switchToEmail": "Utiliser mon adresse email",
      "switchToSms": "Utiliser mon numéro de téléphone",
      "codeTitle": "Saisissez votre code",
      "codeSentTo": "Nous avons envoyé un code à {{contact}}.",
      "codeLabel": "Code à 6 chiffres",
      "codePlaceholder": "123456",
      "codeValidity": "Le code est valable 15 minutes.",
      "submitCode": "Se connecter",
      "resendCode": "Renvoyer un code",
      "changeContact": "Modifier mes coordonnées",
      "codeSentToast": "Code envoyé",
      "connection": "Connexion",
      "back": "Retour"
    },
    "notFound": {
      "title": "La page n'existe pas"
    },
    "patientMonitoring": {
      "agp": {
        "glycemiaMgDl": "Glycémie en mg/dL",
        "longTermEvolution": "Voir l'évolution long terme",
        "title": "Profil AGP"
      },
      "dailyDataError": "Erreur du chargement des données journalières",
      "glycemia": {
        "averageMeasuresPerDay": "Moy. mesures/jour",
        "averageReader": "Moy. gluc. lecteur",
        "averageSensor": "Moy. gluc. capteur",
        "coefVariation": "Coef. variation",
        "estimatedHba1c": "HbA1c estimée",
        "nbHypo": "Nb. hypo.",
        "sensorUsage": "Utilisation capteur",
        "title": "Profils glycémiques journaliers"
      },
      "insulin": {
        "averageInsulinPerDay": "Moy. insuline/jour",
        "averageNbBolusPerDay": "Moy. nb. bolus/jour",
        "averageNbInjectionsPerDay": "Moy. nb. injections/jour",
        "fast": "Insuline rapide",
        "slow": "Insuline lente"
      },
      "loadMoreRecent": "Afficher de la donnée plus récente",
      "noData": "Aucune donnée à afficher",
      "patient": {
        "title": "Informations patient",
        "helperSection": "Aidant à contacter (facultatif)",
        "age": "{{age}} ans",
        "diabetes": {
          "gestational": "Diabète gestationnel",
          "type1": "Diabète type 1",
          "type2": "Diabète type 2"
        },
        "insulin": {
          "insulinPen": "Stylo",
          "insulinPump": "Pompe",
          "noInsulin": "Non insuliné"
        },
        "insulinScheme": "Dispositif d'insulinothérapie",
        "unspecifiedInsulinScheme": "Schéma insulinique non renseigné",
        "unspecifiedDiabetesType": "Type de diabète non renseigné"
      },
      "title": "Suivi du patient"
    },
    "patientMedicalFile": {
      "devices": "Dispositifs médicaux",
      "diabetes": {
        "title": "Diabète"
      },
      "editNote": "Éditer la note",
      "emptyNote": "\"<i>Vous n'avez pas encore de note pour ce patient</i>\"",
      "lastSync": "Donnée la plus récente",
      "neverSynced": "jamais",
      "noteSuccess": "Note sauvegardée avec succès",
      "notes": "Bloc-note équipe médicale",
      "thereIs": "il y a {{duration}}",
      "writeNote": "Rédiger une note"
    },
    "patients": {
      "addPatient": "Ajouter un patient",
      "addNurseInclusion": "Pré-inclure un patient",
      "all": "Tous",
      "diabetesType": "Diabète",
      "editPatient": "Modifier",
      "gestational": "DG actifs",
      "messages": "Messages",
      "monitored": "DT1/2 actifs",
      "notifications": "Télésurveillance",
      "patientInfo": "Informations de votre patient",
      "referentDoctor": "Docteur",
      "telemonitoring": "Télésurveillance",
      "title": "Mes patients",
      "toConsult": "Patient signalé"
    },
    "patientSettings": {
      "telemonitoring": {
        "activate": "Activer la télésurveillance",
        "edit": "Modifier la télésurveillance",
        "title": "Diabète et inscription à la télésurveillance"
      }
    },
    "practitionerBilling": {
      "fileName": "Nom du fichier",
      "lastUpdate": "Dernière mise à jour",
      "noData": "Aucun fichier disponible",
      "period": "Période",
      "status": "Statut",
      "title": "Facturation"
    },
    "renewPopup": {
      "body": "Le télésuivi de votre patient a expiré, il n'est donc plus accompagné par votre infirmier. ​Souhaitez-vous poursuivre son accompagnement ?",
      "decideLater": "Décider plus tard",
      "no": "Non",
      "title": "Renouvellement de votre patient",
      "yes": "Oui"
    }
  },
  "patientEvents": {
    "carePlanDeleted": "Impossible de connecter le patient, un terme a été mis à son suivi.",
    "carePlanRenewed": {
      "other": "{{doctorName}} a renouvelé le télésuivi.",
      "self": "Vous avez renouvelé le télésuivi du patient"
    },
    "decidedNotToRenew": {
      "afterEndCP": {
        "other": "{{doctorName}} a indiqué ne pas renouveler le télésuivi",
        "self": "Vous avez mis un terme au télésuivi du patient"
      },
      "beforeEndCP": {
        "other": "{{doctorName}} a indiqué que le télésuivi ne sera pas renouvelé à l’issue de la prescription en cours",
        "self": "Vous avez mis un terme au télésuivi du patient, à l’issue de la prescription en cours"
      }
    },
    "aircall": {
      "callNotAnswered": "Tentative d'appel du patient par l'équipe Stēto",
      "callAnswered": "Appel entre l'équipe Stēto et le patient - Durée : {{duration}} minutes",
      "smsSentBySteto": "SMS envoyé au patient par l'équipe Stēto",
      "smsSentByPatient": "SMS envoyé par le patient à l'équipe Stēto"
    },
    "header": "Évènement"
  },
  "patientInfo": {
    "countryOfBirth": "Né en",
    "countryOfBirth_female": "Née en",
    "countryOfBirth_male": "Né en",
    "noPhoneNumber": "Téléphone non renseigné",
    "placeOfBirth": "Né à",
    "placeOfBirth_female": "Née à",
    "placeOfBirth_male": "Né à"
  },
  "patientNavigation": {
    "dailyView": "Vue journalière",
    "dataManagement": "Gestion des données",
    "lastSeen": "Actif il y a",
    "medicalFile": "Dossier médical",
    "monitoring": "Suivi diabète",
    "noFirstConnection": "Pas de première connexion",
    "notice": {
      "banner": "Votre infirmier a signalé ce patient",
      "cancelNotify": "Annuler le signalement",
      "mitigateNotify": "Valider le signalement",
      "notified": "Patient signalé",
      "notifyDoctor": "Signaler au médecin"
    },
    "reinclusion": {
      "doctorCTAAccept": "Réinclure",
      "doctorCTADeny": "Refuser",
      "doctorTitle": "Votre infirmier vous propose de réinclure ce patient",
      "doctorTitleWithNurseName": "{{nurseName}} vous propose de réinclure ce patient"
    },
    "reinclusionNudge": {
      "nurseCTACancel": "Annuler la proposition",
      "nurseCTACreate": "Proposer la réinclusion",
      "subtitle": "Ce patient n’est plus télésuivi depuis le",
      "title": "Télésurveillance expirée. Souhaitez-vous proposer au médecin de réinclure ce patient ?",
      "titleReinclusionAlreadyCreated": "Vous avez proposé au médecin de réinclure ce patient"
    },
    "renewalNudge": {
      "ctas": {
        "continue": "Poursuivre le suivi",
        "stop_later": "Arrêter le suivi dans {{days}} jours",
        "stop_now": "Mettre un terme au suivi",
        "stop_today": "Arrêter le suivi aujourd'hui",
        "stop_tomorrow": "Arrêter le suivi demain"
      },
      "expired": "<0>L’ordonnance de {{patientName}} a expiré il y a {{days}} jours.</0> Prévenez votre infirmier si il doit arrêter d’accompagner votre patiente.",
      "expired_yesterday": "<0>L’ordonnance de {{patientName}} a expiré hier.</0> Prévenez votre infirmier si il doit arrêter d’accompagner votre patiente.",
      "expires_soon": "<0>L’ordonnance de {{patientName}} expire dans {{days}} jours.</0> Prévenez votre infirmier si il doit continuer d’accompagner votre patient à l’issue de la prescription en cours.",
      "expires_today": "<0>L’ordonnance de {{patientName}} expire aujourd’hui.</0> Prévenez votre infirmier si il doit continuer d’accompagner votre patient à l’issue de la prescription en cours.",
      "expires_tomorrow": "<0>L’ordonnance de {{patientName}} expire demain.</0> Prévenez votre infirmier si il doit continuer d’accompagner votre patient à l’issue de la prescription en cours."
    },
    "settings": "Télésurveillance"
  },
  "periodicity": {
    "customize": "{{count}} jours",
    "oneMonth": "30 jours",
    "oneWeek": "7 jours",
    "sixMonths": "180 jours",
    "threeMonths": "90 jours",
    "twoWeeks": "14 jours",
    "yesterday": "Hier"
  },
  "prescription": {
    "renew": "Renouveler",
    "sign": "Signer"
  },
  "profile": {
    "address": "Adresse",
    "birth": "Informations de naissance",
    "birthCity": "Ville de naissance",
    "birthCountry": "Pays de naissance",
    "birthDate": "Date de naissance",
    "birthDate_short": "Naissance",
    "birthPlace": "Lieu de naissance",
    "birthPostCode": "Code postal de naissance",
    "diabetologist": "Diabétologue",
    "doctor": "Médecin",
    "email": "Email",
    "female": "Femme",
    "firstname": "Prénom",
    "gender": "Sexe",
    "identityFirstname": "1er prénom de naissance",
    "identityFirstnames": "Prénom(s) de naissance",
    "identityLastname": "Nom de naissance",
    "ins": "Identifiant National de Santé",
    "lastname": "Nom",
    "male": "Homme",
    "moreInfo": "Afficher toutes les informations",
    "notGiven": "Non renseigné",
    "nurse": "Infirmier",
    "oid": "Numéro OID",
    "phone": "Téléphone",
    "profession": "Profession",
    "profile": "Profil",
    "ssn": "Numéro de sécurité sociale",
    "title": "Profil",
    "usedFirstname": "Prénom utilisé",
    "usedLastname": "Nom utilisé"
  },
  "pumpEvents": {
    "category": "Événement",
    "insulin": "Insuline",
    "isNotTemp": "Non",
    "isTemp": "Oui",
    "primeSize": "Taille de la purge",
    "tempRate": "Débit Temp.",
    "tempRatePercent": "Débit temporaire",
    "title": "Événement de pompe"
  },
  "report": {
    "category": "Catégorie",
    "message": "Message",
    "title": "Événement"
  },
  "search": {
    "searchPatient": "Rechercher un patient"
  },
  "support": {
    "byEmail": " par email à ",
    "byPhone": "par téléphone au",
    "contactUs": "Contactez le support",
    "inCaseOfNeed": "En cas de besoin, vous pouvez contacter le support",
    "or": "ou"
  },
  "thresholdSettings": {
    "afterMeal": "Après le repas",
    "alertThresholds": "Seuils des notifications",
    "beforeBreakfast": "À jeun",
    "beforeMeal": "Avant le repas",
    "gestationalThresholds": "Seuils glycémiques",
    "hyperglycemia": "Hyperglycémie",
    "hypoglycemia": "Hypoglycémie",
    "normal": "Glycémie cible",
    "severeHyperglycemia": "Hyperglycémie sévère",
    "severeHypoglycemia": "Hypoglycémie sévère",
    "thresholdUpdated": "Seuil mis à jour",
    "thresholds": "Seuils",
    "units": "mg/dL"
  },
  "QaTools": {
    "deleteData": "Delete",
    "deleteDataTitle": "Delete glycemia data",
    "downloadCSV": "Download CSV",
    "downloadCSVTitle": "Download glycemia data",
    "generateData": "Generate",
    "generateDataTitle": "Generate glycemia data",
    "glycemiaDataManagement": "Glycemia data management",
    "onboarding": "Onboarding management",
    "skipOnboarding": "Skip onboarding",
    "uploadCSV": "Upload CSV",
    "uploadCSVTitle": "Upload glycemia data"
  },
  "appTitle": "Stēto Téléverseur",
  "chrome": "Chrome",
  "electron": "Electron",
  "uploader": "Téléverseur",
  "version": "Version",
  "auth": {
    "login": "Connexion",
    "logout": "Déconnexion",
    "issues": "En cas de difficulté à utiliser l'uploader, vous pouvez",
    "contactSupport": "contacter le support",
    "at": "à",
    "or": "ou au"
  },
  "criticalError": {
    "title": "Erreur",
    "dontHesitateToWrite": "Si le problème persiste, n'hésitez pas à nous écrire à",
    "orCall": "ou bien à nous appeler au",
    "weWillTryOurBest": "Nous nous efforceront de vous assister dans les meilleurs délais.",
    "errors": {
      "unknown": "Une erreur inconnue est survenue. Nos équipes techniques ont été notifiées.\nVous pouvez essayer de quitter puis relancer l'application.",
      "notPatient": "Il semble que vous soyez authentifié avec un compte qui n'est pas un compte patient.\nActuellement, seuls les comptes patients peuvent téléverser leurs données de pompe à travers cette application.\nVeuillez vous déconnecter et vous connecter avec un compte patient."
    }
  },
  "usb": {
    "usbRequired": "Votre navigateur n'est pas compatible avec l'uploader Stēto. Merci d'utiliser Chrome, Edge ou Opéra (lien de téléchargement ci-dessous).",
    "usbRequiredInstructions": "Pourquoi mon navigateur actuel n'est pas compatible ?\nNous avons besoin d'accéder au contenu sur votre pompe via le cable USB,\net seuls les navigateurs Chrome, Edge ou Opéra sont compatibles avec la fonctionnalité USB.",
    "downloadChrome": "Télécharger Chrome",
    "downloadEdge": "Télécharger Edge",
    "downloadOpera": "Télécharger Opera"
  }
}
